module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.isCredit) { 
    ; __append(" <span class=\"text-green\">+")
    ; __append(escapeFn( locals.amount ))
    ; __append("</span> ")
    ;  } else { 
    ; __append(" -")
    ; __append(escapeFn( locals.amount ))
    ; __append(" ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/payment_logs/amount_header.ejs
// module id = 806
// module chunks = 1